import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { AgenteFinanceiro } from "./agente-financeiro.model";

export class HabilitacaoAlternativa extends BaseEntity {

  public agenteFinanceiro: AgenteFinanceiro;
  public valorLimite: number;
  public usuarioADResponsavel: string;
  public nomeUsuarioADResponsavel: string;
  public dataAtualizacao: Date;
  public dataRegistro: Date;
  public dataInicio: Date;
  public dataMaximaValidade: Date;
  public dataSuspensao: Date;
  public justificativaSuspensao: string;
  public usuarioADResponsavelPelaSuspensao: string;
  public situacao: string;

}
